var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',[_c('el-row',{attrs:{"gutter":15}},[_c('el-col',{attrs:{"md":12,"xs":24}}),_c('el-col',{attrs:{"md":12,"xs":24}},[_c('counter')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }